import type { GetInvoiceResponse } from '@weft/api-definition';
import { GetInvoiceResponseSchema } from '@weft/api-definition';
import { validateNotEmptyObject } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useInvoice(invoiceId: string, options?: CustomUseQueryOptions<GetInvoiceResponse>) {
  const invoiceQuery = useQuery(
    ['Invoice', invoiceId],
    async () => {
      const api = getPrivateApi();
      const getInvoiceResponse = await api.getInvoice({ invoiceId });

      return GetInvoiceResponseSchema.parse(getInvoiceResponse);
    }
    , { suspense: true, ...options },
  );

  validateNotEmptyObject(invoiceQuery.data, `Invoice with id ${invoiceId}`);

  return invoiceQuery;
}